<template>
  <div>
    <div :class="size ==='lg' ? 'imageContainer imageContainerLg' : 'imageContainer'">
      <router-link v-if="routerLinkTo" :to="routerLinkTo"
      title="Click here to go directly to this post">
        <img :src="imagePath"/>
      </router-link>
      <a v-if="hyperLinkTo" :href="hyperLinkTo" target="_blank">
        <img :src="imagePath"/>
      </a>
    </div>
    <div v-if='subLink' class="imageContainerSubLink">
      <a :href="subLink" target="_blank"> {{ subTitle }} </a>
    </div>

  </div>
</template>
<script>
export default {
  name: 'ImageContainer',
  props: ['size', 'routerLinkTo', 'hyperLinkTo', 'imagePath', 'subLink', 'subTitle']
}
</script>
